import { render } from "./beautyEdu.vue?vue&type=template&id=70a3e889&scoped=true"
import script from "./beautyEdu.vue?vue&type=script&lang=js"
export * from "./beautyEdu.vue?vue&type=script&lang=js"

import "./beautyEdu.vue?vue&type=style&index=0&id=70a3e889&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a3e889"]])

export default __exports__